<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <NotificationContainer v-if="!!message" class="messages-container" :message = "message"/>
        <ErrorsContainer class="messages-container" :errors = "errors"/>
        <p><b>Updates answers of all assignment terms, which belong to a specified vendor.</b></p>
        <div>
          <b-form @submit.prevent="submitForm" v-promise-btn="{action: 'submit'}">
            <b-row>
              <VendorProductSearch @applyVendorId="applyVendorId" @applyProductId="applyProductId"/>
            </b-row>
            <b-row class="my-1">
              <b-col sm="2">
                <label for="addAnswerUuids">Add Answer UUIDs: </label>
              </b-col>
              <b-col sm="8">
                <b-form-textarea id="addAnswerUuids"
                                 type="text"
                                 rows="2"
                                 :required="!answersInputsFilled"
                                 v-model="formData.addAnswerUuids"
                                 placeholder="Answer UUIDs should be comma separated."/>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="2">
                <label for="removeAnswerUuids">Remove Answer UUIDs: </label>
              </b-col>
              <b-col sm="8">
                <b-form-textarea id="removeAnswerUuids"
                                 type="text"
                                 rows="2"
                                 :required="!answersInputsFilled"
                                 v-model="formData.removeAnswerUuids"
                                 placeholder="Answer UUIDs should be comma separated."/>
              </b-col>
            </b-row>
            <b-col md="auto">
              <b-button type="submit" variant="success" :disabled="!formSubmittable"> Run </b-button>
            </b-col>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import OptionIdsMaintenanceProvider from '@/services/OptionIdsMaintenanceProvider'
import NotificationContainer from '@/components/NotificationContainer'
import ErrorsContainer from '@/components/ErrorsContainer'
import VendorProductSearch from '@/components/AdminPanel/OptionIdsMaintenance/VendorProductSearch'

export default {
  name: 'UpdateAnswersOfVendor',
  data () {
    return {
      formData: {
        vendorId: null,
        productId: null,
        addAnswerUuids: null,
        removeAnswerUuids: null
      },
      message: '',
      errors: []
    }
  },
  components: {
    VendorProductSearch,
    NotificationContainer,
    ErrorsContainer
  },
  computed: {
    answersInputsFilled: function () {
      return this.formData.addAnswerUuids || this.formData.removeAnswerUuids
    },
    formSubmittable: function () {
      return this.formData.vendorId &&
        this.formData.productId
    }
  },
  methods: {
    applyVendorId: function (value) {
      this.formData.vendorId = value
    },
    applyProductId: function (value) {
      this.formData.productId = value
    },
    submitForm: function () {
      this.errors = []
      return new Promise((resolve, reject) => {
        OptionIdsMaintenanceProvider.updateAnswersOfVendor(this.formData)
          .then((resp) => {
            this.message = resp.body['message']
            resolve(resp)
          }, (resp) => {
            this.errors = resp.body.errors
            resolve(resp)
          })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.messages-container {
  margin-bottom: 15px;
}
</style>
